export const messages = {
  updatedTerms: 'To start using the service, please accept Terms and Conditions',
  toStartUsing: '',
  declineAndLogOut: 'Decline and Log Out',
  accept: 'Accept',
};
